module.exports = __webpack_public_path__ + "img/client_registry_ozk_ug.7c255848.png";